<template>
  <div class="pc-container">
    <div v-for="(item,index) in data" :key="index">
      <component :is="item.type" :data="item"></component>
    </div>
  </div>
</template>

<script>
import {homeData} from "@/data";
export default {
  name: 'HomeView',
  data(){
    return {
      data:homeData
    }
  }
}
</script>
<style lang="scss" scoped></style>
